export { RiskDisclosurePage as default } from "@nvb/ui";
